import {MDIcon, MDIconSize} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {Spinner, SpinnerSize, SpinnerStyle, SpinnerWeight} from '@mintdata-wsp/common/components/spinner/Spinner';
import {CopyPagesState, VersionInfo} from '@mintdata-wsp/common/state/ui/visualDesigner/CopyPagesState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {CustomDropdown} from '@mintdata-wsp/wsp/ui/components/customDropdown/CustomDropdown';
import {PopupAnchor, SourceAnchor} from '@mintdata/mint-kit/impl/components/popover/PopupTypes';
import {Tooltip} from '@mintdata/mint-kit/impl/components/tooltip/Tooltip';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./VersionsDropdown.less');
const cx = classnames.bind(styles);

interface VersionsDropdownProps
{
    className?:string,
}

@observer
export class VersionsDropdown extends React.Component<VersionsDropdownProps, any>
{
    @bind
    private _handleDropdownClick():void
    {
        const {copyPages} = controllers.ui;
        copyPages.loadVersionsAsync();
    }

    @bind
    private _getListItemClickHandler(version:VersionInfo, closePopoverFunc:() => void):(event:React.MouseEvent<any>) => void
    {
        return (event:React.MouseEvent<any>):any =>
        {
            closePopoverFunc();
            controllers.ui.copyPages.onVersionSelected(version.id);
        };
    }

    @bind
    private _renderVersionsList(closePopoverFunc:() => void):JSX.Element
    {
        const {copyPages} = controllers.ui;
        const copyState:CopyPagesState = copyPages.getState();
        const {designState: {selectedVersionId}, versions, versionsLoading} = copyState;

        return (
            <div className={cx('listWrapper')}>
                <div className={cx('listTitle')}>Design version</div>
                <div className={cx('list')}>
                    {versionsLoading && <div
                        className={cx('spinnerWrapper')}
                    >
                        <Spinner
                            size={SpinnerSize.Medium_24}
                            style={SpinnerStyle.Blue}
                            className={cx('spinner')}
                            weight={SpinnerWeight.Thin}
                        />
                    </div>
                    }

                    {!versionsLoading && versions.map((version:VersionInfo) => (
                        <div
                            className={cx('listItem', {selected: version.id === selectedVersionId})}
                            onClick={this._getListItemClickHandler(version, closePopoverFunc)}
                            key={version.id}
                        >
                            <p className={cx('name')}>{version.name}</p>
                            {version.description && <p className={cx('desc')}>{version.description}</p>}
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    @bind
    private _renderIcon():JSX.Element
    {
        const {copyPages} = controllers.ui;
        const copyState:CopyPagesState = copyPages.getState();
        const {designState: {selectedVersionId, selectedDesignId}, versions} = copyState;
        const versionSelected:VersionInfo = versions.find((version:VersionInfo) => version.id === selectedVersionId);

        return <Tooltip content={versionSelected ? versionSelected.name : null} targetClassName={cx('tooltip')}>
            <MDIcon className={cx(
                'icon',
                {blue: selectedDesignId && versions.length > 0 && selectedVersionId !== -1},
                {disabled: !selectedDesignId}
            )}
                    name={MDIcons.common.Versions}
                    size={MDIconSize.medium16}
            />
        </Tooltip>;
    }

    render():JSX.Element | false | null
    {
        const {className} = this.props;
        const {copyPages} = controllers.ui;
        const copyState:CopyPagesState = copyPages.getState();

        return <CustomDropdown
            className={cx('base', {[className]: !!className})}
            ddIcon={this._renderIcon()}
            renderListFunc={this._renderVersionsList}
            popoverProps={{
                sourceAnchor: SourceAnchor.RightBottom,
                popupAnchor: PopupAnchor.RightTop,
            }}
            onClick={this._handleDropdownClick}
            disabled={!copyState.designState.selectedDesignId}
        />;
    }
}
